// Text fürs Speichern-Overlay (Admin + Self-Service). Seit dem Sammel-Speichern
// (2026-09-14) benennt der Server beim Speichern Sprachproben synchron auf der
// Cloud um — bei Namensänderung alle Proben der Person. Das dauert spürbar,
// deshalb sagt das Overlay, was passiert, und bittet, das Fenster offen zu lassen.
//
// `lang` nur für die zweisprachige Self-Service-Fläche (2026-09-15); der Admin
// ruft ohne Sprache auf und bleibt deutsch.
export function saveStatusText(renameCount: number, lang: 'de' | 'en' = 'de'): string {
  if (lang === 'en') {
    if (renameCount <= 0) return 'Saving …';
    const what = renameCount === 1 ? 'one voice sample is' : `${renameCount} voice samples are`;
    return `Saving … ${what} being renamed in the cloud.\nPlease don't close this window.`;
  }
  if (renameCount <= 0) return 'Speichert …';
  const was = renameCount === 1 ? 'eine Sprachprobe wird' : `${renameCount} Sprachproben werden`;
  return `Speichert … ${was} in der Cloud umbenannt.\nBitte Fenster nicht schließen.`;
}
